import { Component, Input, OnInit, ElementRef, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { GAMESTATUS, GAMETYPES } from "../../../../shared/constants/constants";
import { GameMessageType, GameModalMessage, GameModel } from "../../../../shared/constants/divisional.interface";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GameService } from '../../../../shared/services/game/game.service';
import moment from 'moment-mini';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'game-card',
    templateUrl: './game-card.component.html',
    styleUrls: ['./game-card.component.scss']
})
export class GameCardComponent implements OnInit, AfterViewInit {

    public _windowUtil = (window: any) => {
        function getWindowLocationHref(): string {
            return window.location.href;
        }
        function setWindowLocationHref(path: string): void {
            window.location.href = path;
        }

        return {
            getWindowLocationHref: getWindowLocationHref,
            setWindowLocationHref: setWindowLocationHref,
        }
    }
    public windowUtil = this._windowUtil(window);
    public optinEnhancements: boolean = false;
    public isSingleCard: boolean = false;
    public GAMESTATUS: any = GAMESTATUS;
    public GAMETYPES: any = GAMETYPES;
    public gameEndStatus: string = "";
    public remainingDaysOrweeks: string = "";
    public displayNumberOfDaysOrWeeksRemaining: boolean = false;
    public imagePath: string;
    public sm = '575px';
    public md = '768px';
    private currentEnvironment;

    @Input() userInfo: any;
    @Input() game: GameModel;
    @Input() optInStatus: boolean = false;
    @Input() validStore: boolean;
    @Input() howItWorksNewUser: string = "";
    @Input() howItWorksExistingUser: string = "";
    @Input() sweepstakesEntriesInfo: string = "";
    @Input() programRulesLink: string = "";
    @Input() programFAQLink: string = "";
    @Input() tokenLabelSingular: string = "";
    @Input() tokenLabelPlural: string = "";
    @ViewChild('howItWorksLink') howItWorksLinkEle: ElementRef;
   
    @Input()
    set singleCard(value: boolean) {
        this.isSingleCard = value;
    };
    get singleCard(): boolean {
        return this.isSingleCard
    }

    @ViewChild( 'howItWorks', { read: TemplateRef }) howItWorks: TemplateRef<any>;
    public howItWorksRef: BsModalRef = null;
    public gameDetails: any = null;
    public gameModalMessageObserver: any = null;
    howItWorksOnShownSubscription: Subscription = null;

    constructor(public elementRef: ElementRef, public gameService: GameService, public router: Router, private modalService: BsModalService) { }

    ngOnInit(): void {
        this.currentEnvironment = this.gameService.getEnvironment();
        this.optinEnhancements = this.gameService.optinEnhancements;
        this.imagePath = environment[this.currentEnvironment].imagePath;
        this.optinEnhancements = this.gameService.optinEnhancements;
        try {
            this.setGameEndStatus(this.game);
            this.gameDetails = JSON.parse(this.game.details);
        } catch (e) {

        }

        this.gameModalMessageObserver = this.gameService.gameModalMessageObservable.subscribe(message => {
            if (message && message.mode == GameMessageType.SHOWHOWITWORKS) {
                this.showHowItWorks();
            }
        });

        // Listen for the modal close backdrop-click event
        this.modalService?.onHide?.subscribe((reason: string | any) => {
            if (reason === 'backdrop-click' && !this.game.howItWorks && this.optinEnhancements) {
                this.handlehowItWorks();
            }
        });

    }

    ngAfterViewInit() {
        const btnElement = this.elementRef.nativeElement.querySelector('.game-image');
        const updateBackgroundImage = () => {
            if (btnElement) {
                btnElement.style.backgroundImage = this.getBackgroundImageUrl(this.game.code);
                btnElement.style.backgroundRepeat = 'no-repeat';
                btnElement.style.backgroundSize = '100% 100%';
            }
        }
        // Initial call to set the background image
        updateBackgroundImage();
        // Add event listener for window resize
        if(this.singleCard) {
            window.addEventListener('resize', updateBackgroundImage);
        }
        if (!this.optInStatus && this.isSingleCard) {
            if (this.getParameterByName('dialog') == 'optin' && this.game && !this.game.disableGamePlay) {
                this.showOptIn();
            } else if(!this.game.howItWorks) {
                this.showHowItWorks();
            }
        } 
    }

    public getBackgroundImageUrl(code: string, viewport?: string): string {
        let imageRef = '';
        let imgPath = '';
        if (this.imagePath) {
            const modifiedImagePath = this.imagePath.replace(/\$.*/,'');
            if (this.isSingleCard) {
                imgPath = window.innerWidth > 480 ? '-GDP-background?scl=2' : '-GC-background?scl=2';
                imageRef = 'url(' + modifiedImagePath + code + imgPath + ')'
            } else {
                imgPath = '-GC-background?scl=2';
                imageRef = 'url(' + modifiedImagePath + code + imgPath + ')'
            }
        }

        return imageRef;
    }

    public getIconImageUrl(code: string, viewport?: string): string {
        let imgPath;
        if(this.isSingleCard) {
            imgPath = '-GDP-icon?';
        } else {
            imgPath = '-GC-icon?';
        }
        
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}?$ecom-product-card-${viewport}-jpg$&', code + imgPath) : '';
    }

    public getImageUrl(code: string, viewport?: string): string {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}?$ecom-product-card-${viewport}-jpg$&', code + '?') : '';
    }

    public shortDate(dateString: string, splitter: string = "/") : string {
        return this.gameService.shortDate(dateString, splitter);
    }

    public setGameEndStatus(game) {
        const today = new Date();
        const endDate = game.endDate;
        const postProgLiveDate = game.postProgLiveDate;
        if(today < endDate) {
            const diffInTime = endDate.getTime() - today.getTime();
            const dffInDays = Math.floor(diffInTime/(1000*60*60*24));
            if(dffInDays > 14) {
                this.gameEndStatus =  `Ends ${this.shortDate(game.endDateString)}`;
                this.displayNumberOfDaysOrWeeksRemaining = false;
                this.remainingDaysOrweeks = `${dffInDays} days left to shop`
            } else {
                this.gameEndStatus =  "Ending Soon";
                this.displayNumberOfDaysOrWeeksRemaining = true;
                if(dffInDays !== 0 && dffInDays % 7 == 0) {
                    this.remainingDaysOrweeks = `${dffInDays/7} week${dffInDays/7 ==1 ? '':'s'} left to shop`
                } else {
                    this.remainingDaysOrweeks = `${dffInDays} day${dffInDays ==1?'':'s'} left to shop`
                }
            }

        } else {
            const diffInTime = postProgLiveDate.getTime() - today.getTime();
            const dffInDays = Math.floor(diffInTime/(1000*60*60*24));
            this.gameEndStatus =  "Ended";
            this.displayNumberOfDaysOrWeeksRemaining = true;
            this.remainingDaysOrweeks = `${dffInDays} day${dffInDays ==1?'':'s'} remaining`;
        }
        
    }

    public openDetails(event) {
        event.stopPropagation();
        console.error(this.isSingleCard, this.validStore, 'this.isSingleCard && this.validStore')
        if (!this.isSingleCard && this.validStore) {
            if(this.game.gameStatus === 'Game Over' && this.game.type === 'EPISODIC' ) {
                localStorage.setItem('episodic_game_name', this.game.name);
                this.router.navigate(['games/game-over', this.game.code]);
                return;
            }
            this.router.navigate(['games/game-details', this.game.code]);
        }

        if (!this.isSingleCard && !this.validStore) {
            let message: GameModalMessage = {
                mode: GameMessageType.INELIGIBLE,
                gameId: this.game.code || '',
                gameName: this.game.name || '',
                rulesLink: this.game.rulesurl || ''
            }
            this.gameService.gameModalMessage.next(message);
        }

    }

    public handlehowItWorks() {
        this.gameService.handleHowItWorks(this.userInfo, this.game.code).subscribe((response) => {
            console.info('How it works popup closed successfully', response);
        }, error => {
            console.error('Error in fetching how it works', error);
        });
    }

    public closeHowItWorks() {
        this.howItWorksRef.hide();
        this.howItWorksOnShownSubscription && this.howItWorksOnShownSubscription.unsubscribe();
        if(!this.game.howItWorks && this.optinEnhancements) {
            this.handlehowItWorks();
        }
        this.howItWorksLinkEle.nativeElement.focus();
        this.analyticsModalTracking('how-it-works|close', 'click');
    }

    public showHowItWorks() {
        this.howItWorksOnShownSubscription = this.modalService.onShown.subscribe(() => {
            window['AB'].DIVISIONAL.modalTrapKeyboard(".how-it-works-dialog");
            let button = document.getElementById("how-it-works-close");
            if (button) {
                button.focus();
            }
        });
        this.howItWorksRef = this.modalService.show(this.howItWorks, { class: 'episodic-modal-dialog how-it-works-dialog', ariaLabelledBy: 'how-it-works-title'});      
        this.analyticsModalTracking('how-it-works|view', 'view');
    }

    public showOptIn() {
        this.howItWorksRef && this.howItWorksRef.hide();
        this.howItWorksOnShownSubscription && this.howItWorksOnShownSubscription.unsubscribe();
        let message: GameModalMessage = {
            mode: GameMessageType.SHOWOPTIN
        }
        this.gameService.gameModalMessage.next(message);
        this.analyticsModalTracking('how-it-works|start-playing', 'click');
    }

    getParameterByName = function (name) {
        const match = RegExp('[?&]' + name + '=([^&]*)', 'i').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    };

    public getTokenLabel(tokens: string) {

        let val = parseInt(tokens) || 0;
        
        return (val == 1) ? this.tokenLabelSingular : this.tokenLabelPlural;
    }

    public formatDate(date: string): string {

        const dateObject = new Date(date);
        return moment(dateObject).format("dddd MMMM Do yyyy");
    }

    public analyticsModalTracking(modalAction, event) {
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.setGamesModalEvents(this.game.code, modalAction, event);
            if (modalAction === 'how-it-works|view') {
                window['AB'].DATALAYER.gamesModalHandler(this.game.code, 'how-it-works|close');
            }
        }
    }

    ngOnDestroy() {
        this.gameModalMessageObserver && this.gameModalMessageObserver.unsubscribe();
    }
}
